/* eslint-disable no-console */
/* eslint-disable no-undef */
export var sendEvent = function sendEvent(payload) {
  var _window = window,
    Lurker = _window.Lurker;
  if (Lurker && process.env.NODE_ENV === 'production') {
    Lurker.send(payload);
  } else {
    console.log('Lurker debug event: ' + JSON.stringify(payload));
  }
};
export default sendEvent;